export default function isOSMUnnamed(
    properties: mapboxgl.MapboxGeoJSONFeature['properties'] | undefined
) {
    return !(properties?.name || properties?.title);
}
